import React from "react";

const Main = () => {

    return (
        <div className={"main"}>Page not found</div>



    )
}

export default Main;
